// extracted by mini-css-extract-plugin
export var breadcrumb = "_k-0";
export var breadcrumbArrow = "_k-1";